<form [formGroup]="dynamicForm" autocomplete="off" #formElement (ngSubmit)="onSubmit()">
  <div [ngClass]="border ? 'border rounded-3 p-3 pb-4' : ''">
    <div class="row row-cols-1 g-4" [ngClass]="rowClass">
      <ng-container *ngFor="let field of sortedFields">
        <div [class]="rowClass ? 'col' : field.class">
          <ng-container [ngSwitch]="field.type">
            <div *ngSwitchCase="typeFieldEnum.Input">
              <label [for]="field.name">{{ field.label }}</label>
              <input nz-input [id]="field.name" [formControlName]="field.name" nzSize="large"
                  [placeholder]="field.placeholder || field.label" uppercase [mostrarUppercase]="field.mostrarUppercase" />
            </div>

            <div *ngSwitchCase="typeFieldEnum.Select">
              <label [for]="field.name">{{ field.label }}</label>
              <nz-select [id]="field.name" [nzSize]="'large'" [nzPlaceHolder]="'-'" nzAllowClear nzShowSearch
                [formControlName]="field.name" [compareWith]="compareFn">
                <nz-option [nzValue]="getOptionValue(item, field?.optionValueFn)"
                  [nzLabel]="getOptionLabel(item, field?.optionLabelFn)"
                  *ngFor="let item of getFieldList(field.name)"></nz-option>
              </nz-select>
            </div>

            <div *ngSwitchCase="typeFieldEnum.SelectMultiple">
              <ng-container *ngIf="field.nzBlur">
                <label [for]="field.name">{{ field.label }}</label>
                <nz-select [id]="field.name" [nzSize]="'large'" [nzPlaceHolder]="'-'" nzAllowClear nzShowSearch
                  nzMode="multiple" [formControlName]="field.name" [nzMaxTagCount]="2"
                  [nzMaxTagPlaceholder]="tagPlaceHolder" [compareWith]="compareFn"
                  [nzAutoClearSearchValue]="field.nzAutoClearSearchValue !== false" (nzOpenChange)="onDropdownOpenChange($event, field.name)">
                  <nz-option [nzValue]="getOptionValue(item, field?.optionValueFn)"
                    [nzLabel]="getOptionLabel(item, field?.optionLabelFn)" *ngFor="let item of getFieldList(field.name)">
                  </nz-option>
                </nz-select>
                <ng-template #tagPlaceHolder let-selectedList>mais {{ selectedList.length }}</ng-template>
              </ng-container>
              
              <ng-container *ngIf="!field.nzBlur">
                <label [for]="field.name">{{ field.label }}</label>
                <nz-select [id]="field.name" [nzSize]="'large'" [nzPlaceHolder]="'-'" nzAllowClear nzShowSearch
                  nzMode="multiple" [formControlName]="field.name" [nzMaxTagCount]="2"
                  [nzMaxTagPlaceholder]="tagPlaceHolder" [compareWith]="compareFn"
                  [nzAutoClearSearchValue]="field.nzAutoClearSearchValue !== false">
                  <nz-option [nzValue]="getOptionValue(item, field?.optionValueFn)"
                    [nzLabel]="getOptionLabel(item, field?.optionLabelFn)" *ngFor="let item of getFieldList(field.name)">
                  </nz-option>
                </nz-select>
                <ng-template #tagPlaceHolder let-selectedList>mais {{ selectedList.length }}</ng-template>
              </ng-container>
            </div>

            <div *ngSwitchCase="typeFieldEnum.DatePicker">
              <label [for]="field.name">{{ field.label }}</label>
              <nz-date-picker [id]="field.name" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
                [nzPlaceHolder]="field.placeholder || field.label" [formControlName]="field.name"></nz-date-picker>
            </div>

            <div *ngSwitchCase="typeFieldEnum.InputNumber">
              <label [for]="field.name">{{ field.label }}</label>
              <nz-input-number [id]="field.name" [formControlName]="field.name" [nzMin]="field.min ?? 0"
                [nzMax]="field.max ?? 10000" [nzStep]="1" nzSize="large"
                [nzPlaceHolder]="field.placeholder || field.label" class="w-100"></nz-input-number>
            </div>

            <div *ngSwitchCase="typeFieldEnum.TextArea && field.dentroForm">
              <label [for]="field.name">{{ field.label }}</label>
              <nz-textarea-count [nzMaxCharacterCount]="2000">
                <textarea nz-input [id]="field.name" [maxlength]="2000" rows="4" [formControlName]="field.name"
                  [placeholder]="field.placeholder || field.label"></textarea>
              </nz-textarea-count>
            </div>
          </ng-container>
        </div>

        <div class="col-12 col-sm-8 d-flex justify-content-end align-items-end" *ngIf="isCena">
          <button nz-button nzType="primary" type="button" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 btn-secondary-color me-2"
            (click)="selecionarTodos()" *ngIf="isSelecionarTodos">
            Selecionar Todos
            <span class="fs-4 ms-2 icon-park-outline--list fw-normal"></span>
          </button>
          <button nz-button nzType="primary" type="button" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 btn-secondary-color me-2"
            (click)="reaproveitar()" *ngIf="isReaproveitar">
            Reaproveitar
            <span class="fs-4 ms-2 system-uicons--reuse fw-normal"></span>
          </button>
          <button nz-button nzType="default" type="button" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 me-2" (click)="cadastrarNovo()">
            Cadastrar Novo
            <span class="fs-4 ms-2 icons8--plus fw-normal"></span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="row mt-2">
    <ng-container *ngFor="let field of sortedFields">
      <ng-container [ngSwitch]="field.type">
        <div *ngSwitchCase="typeFieldEnum.TextArea">
          <div [ngClass]="field.class ? field.class : 'col'">
            <label [for]="field.name">{{ field.label }}</label>
            <nz-textarea-count [nzMaxCharacterCount]="2000">
              <textarea nz-input [id]="field.name" [maxlength]="2000" rows="4" [formControlName]="field.name"
                [placeholder]="field.placeholder || field.label"></textarea>
            </nz-textarea-count>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="col" *ngIf="!isCena">
    <ng-container [ngSwitch]="formType">
      <div *ngSwitchCase="formTypeEnum.Filter">
        <div class="row d-flex justify-content-end mt-4">
          <ng-container *ngIf="isShowActive">
            <!-- <div class="col-sm-2"> -->

              <div class="col-sm-2">
              <button nz-button nz-dropdown type="button" [nzDropdownMenu]="menuReports" nzSize="large" 
              class="fw-semibold rounded-3 w-100 fs-6 bg-warning text-white border-warning">
              Gerar Relatório
              <span nz-icon nzType="down" class="ms-2 align-middle"></span>
            </button>

              <nz-dropdown-menu #menuReports="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item type="button" (click)="reportSinopse()">Gerar em PDF</li>
                  <li nz-menu-item type="button" (click)="reportSinopseXLSX()">Gerar em XLSX (Excel)</li>
                </ul>
              </nz-dropdown-menu>
            </div>  

              <!-- <button nz-button nzType="default" type="button" nzSize="large"
                class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 bg-warning text-white border-warning" (click)="reportSinopse()">
                Gerar Relatório
              </button> -->
            
            
            <div class="col-sm-2">
              <button nz-button nz-dropdown type="button" [nzDropdownMenu]="menuAcoes" nzSize="large" 
              class="fw-semibold rounded-3 w-100 fs-6 bg-warning text-white border-warning">
              Ações
              <span nz-icon nzType="down" class="ms-2 align-middle"></span>
            </button>

              <nz-dropdown-menu #menuAcoes="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item type="button" (click)="gerarSinopse()">Gerar Sinopse</li>
                  <li nz-menu-item type="button" (click)="aprovarTodos()">Aprovar Sinopses</li>
                  <li nz-menu-item type="button" (click)="reprovarTodos()">Reprovar Sinopses</li>
                </ul>
              </nz-dropdown-menu>
            </div>            
          </ng-container>


          <div class="col-2">
            <button nz-button nzType="default" type="button" nzSize="large"
              class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6" (click)="reset()">
              Limpar filtro
              <span class="fs-3 ms-2 mdi--garbage-can-outline"></span>
            </button>
          </div>
          <div class="col-3 pe-1">
            <button nz-button nzType="primary" type="submit" nzSize="large"
              class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6">
              Buscar
              <span class="fs-3 ms-2 mdi--search"></span>
            </button>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="formTypeEnum.Submit">
        <div class="row d-flex justify-content-end mt-4">
          <div class="col-2">
            <button nz-button nzType="default" type="button" nzSize="large"
              class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6" (click)="back()">
              <!--{{ visualizar ? 'Voltar' : 'Cancelar' }}-->
              Voltar
              <span class="fs-4 ms-2 carbon--arrow-left fw-normal"></span>
            </button>
          </div>
          <ng-container *ngIf="!visualizar">
            <div class="col-3 pe-1">
              <button nz-button nzType="primary" type="submit" nzSize="large"
                class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6"
                [ngClass]="acao == routeActionEnum.Inserir ? '' : 'btn-primary-color'">
                {{ acao == routeActionEnum.Inserir ? 'Cadastrar' : 'Salvar' }}
                <span class="fs-4 ms-2"
                  [ngClass]="acao == routeActionEnum.Inserir ? 'material-symbols-light--select-window' : 'gg--check-o'"></span>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</form>
